import React, { type FunctionComponent } from 'react'
import { Text } from '../../text/Text'

interface DateRangePickerLabelProps {}

export const DateRangePickerLabel: FunctionComponent<DateRangePickerLabelProps> = ({
  children,
}) => (
  <Text weight="semibold" css={{ marginBottom: 8 }}>
    {children}
  </Text>
)
